<ng-container>
  <div clas="card-content">
    <img [src]="imageSrc" class="card-image" />

    <div class="card-last-four">
      <span>**** **** **** {{ data.lastFour }}</span>
    </div>
    <div class="card-expiry-date">
      <span>{{ data.expiryDate }}</span>
    </div>
    <div class="card-player-name">
      <span>{{ data.playerName }}</span>
    </div>
  </div>
</ng-container>
